/** Skip full React splash on repeat loads in the same tab session (faster return visits). */
const SPLASH_SEEN_KEY = 'daiv_splash_seen_session';

export function shouldSkipSplashThisSession() {
  if (typeof window === 'undefined') return false;
  try {
    return sessionStorage.getItem(SPLASH_SEEN_KEY) === '1';
  } catch {
    return false;
  }
}

/** Deep links (ads, WhatsApp, shared pooja URL) — skip animated splash for faster first paint. */
/** Mobile homepage: skip animated splash unless explicitly re-enabled (LCP / TTI). */
export function shouldSkipMobileSplashForPerf() {
  if (typeof window === 'undefined') return false;
  if (process.env.REACT_APP_ENABLE_SPLASH_MOBILE === 'true') return false;
  return window.matchMedia('(max-width: 768px)').matches;
}

export function shouldSkipSplashForPath(pathname) {
  if (!pathname || typeof pathname !== 'string') return false;
  const p = pathname.replace(/\/$/, '') || '/';
  /* Home LCP: splash-mark + React splash compete with the featured pooja image. */
  if (p === '/') return true;
  if (p.startsWith('/pooja/')) return true;
  if (p.startsWith('/thank-you/')) return true;
  if (p.startsWith('/invoice/')) return true;
  if (p === '/pay' || p.startsWith('/pay/')) return true;
  if (p.startsWith('/feedback/')) return true;
  if (p.startsWith('/order-confirmed/')) return true;
  if (p.startsWith('/live-tv')) return true;
  if (p.startsWith('/live-chat/')) return true;
  if (p === '/mobile-app/privacy-policy') return true;
  if (p === '/mobile-app/terms-and-conditions') return true;
  return false;
}

export function markSplashSeenThisSession() {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(SPLASH_SEEN_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function hideStaticHtmlSplash() {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.add('daiv-static-splash-hidden');
}
